// Runtime detection + Tauri-only helpers. Importing from this module is
// safe in the web build — the heavy `@tauri-apps/*` packages are loaded
// dynamically and only when we detect a Tauri environment.
//
// Tauri 2 changed which globals are exposed:
//   - window.__TAURI__               legacy (Tauri 1, sometimes still set)
//   - window.__TAURI_INTERNALS__     always present in Tauri 2 windows
//   - window.isTauri                 Tauri 2 convenience flag
// Checking all three covers every Tauri version we care about.

export const isTauri = (): boolean => {
  if (typeof window === "undefined") return false;
  const w = window as unknown as Record<string, unknown>;
  return (
    "__TAURI__" in w ||
    "__TAURI_INTERNALS__" in w ||
    "isTauri" in w
  );
};

export type DesktopEnvironment = {
  platform: "windows" | "macos" | "linux" | "ios" | "android" | "unknown";
  appVersion: string;
  isTauri: true;
};

let _env: DesktopEnvironment | null = null;

export async function getDesktopEnvironment(): Promise<DesktopEnvironment | null> {
  if (!isTauri()) return null;
  if (_env) return _env;
  const [{ platform }, { getVersion }] = await Promise.all([
    import("@tauri-apps/plugin-os"),
    import("@tauri-apps/api/app"),
  ]);
  const p = await platform();
  const v = await getVersion();
  _env = {
    platform: p as DesktopEnvironment["platform"],
    appVersion: v,
    isTauri: true,
  };
  return _env;
}
